module.exports = __webpack_public_path__ + "media/give.4a5b934b.wav";